import { render, staticRenderFns } from "./withdrawRecordDetail.vue?vue&type=template&id=d60b9de8&scoped=true&"
import script from "./withdrawRecordDetail.vue?vue&type=script&lang=js&"
export * from "./withdrawRecordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60b9de8",
  null
  
)

export default component.exports